<template>
  <span>
    <v-app-bar
      id="core-bar"
      absolute
      app
      color="transparent"
      flat
      style="height: 48px;"
    >
      <v-btn
        color="success darken-2"
        class="mr-3"
        elevation="1"
        fab
        x-small
        @click="onClickBtn"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>

      <v-toolbar-title
        class="hidden-sm-and-down font-weight-light"
        v-text="$route.name"
      />
      <v-spacer />

      <notificacoes> </notificacoes>

      <v-menu
        bottom
        left
        offset-y
        origin="top right"
        transition="scale-transition"
      >
      
        <template v-slot:activator="{ attrs, on }">
          <v-avatar
            v-bind="attrs"
            v-on="on"
            color="success"
            x-small
            style="height: 32px; min-width: 32px; width: 32px;"
          >
            <div class="text-center">
              <v-progress-circular
                v-show="loading"
                indeterminate
                color="white"
              ></v-progress-circular>
            </div>
            <v-img
              v-show="!loading"
              :src="avatar"
              v-if="avatar"
              alt="Usuario"
            >
            </v-img>
            <v-icon
              v-show="!loading"
              v-if="!avatar"
              dark
              large
              color="white"
            >mdi-account-circle</v-icon>
          </v-avatar>          
        </template>

        <v-list>
          <v-subheader> {{ email }} </v-subheader>
          <v-divider></v-divider>
          <v-list-item link @click="openMyProfile">
            <v-list-item-icon>
              <v-icon color="success"> mdi-head </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Meu Perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon color="success"> mdi-login-variant </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
            <!--<v-list-item-title @click="openMyProfile"> <span class="white--text"> Meu Perfil </span> </v-list-item-title>            
            <v-list-item-title @click="logout"> <span class="white--text"> Logout </span> </v-list-item-title>    -->        
          </v-list-item>
        </v-list>
      </v-menu>

     <!-- <v-btn icon @click="logout" :loading="isLoading"> <v-icon color="black">mdi-login-variant</v-icon> </v-btn> -->

    </v-app-bar>

    <v-dialog v-model="dialog" scrollable persistent width="860px">     <!-- scrollable -->
      <v-card>
        <v-card-title class="success">
          <span class="title font-weight-light white--text">Meu Perfil de Usuário</span>
        </v-card-title>
        <v-card-text>
          <cadastro-usuario :perfil="true" ref="formPerfilUsuario" v-if="dialog" @close="fecharModal"></cadastro-usuario>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" text @click="fecharModal" v-show="!loadingStore">Voltar</v-btn>
          <v-btn color="success darken-1" text v-on:click.prevent="callGravar" :loading="loadingStore">Salvar</v-btn>
        </v-card-actions>
      </v-card>  
    </v-dialog> 
  </span>

</template>

<script>

import CadastroUsuario from "@/views/Usuario/CadastroUsuario"
import Notificacoes from "./Notificacoes"

import {
  mapMutations,
  mapState,
  mapActions,
} from 'vuex'

export default {
  components: {CadastroUsuario, Notificacoes},
  data: () => ({
    title: null,
    responsive: false,
    drawer: null,
    drawerRight: null,
    right: false,
    left: false,
    dialog: false,
    loading: false,
  }),

  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations({
      setDrawer: 'app/setDrawer', 
      toggleDrawer: 'app/toggleDrawer'
    }),
    ...mapActions({
      actUsuarioSelecionado: 'usuario/USUARIO_SELECTED',
      actResetUsuarioSelecionado: 'usuario/RESET_SELECTED',
    }),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    logout: function () {
      this.loading = true
      this.$store.dispatch('login/auth_logout')
      .then(() => this.$router.push({path: '/login'}))
      .catch(err => {
        this.$router.push({path: '/login'})
      })
      .finally(()=>this.loading=false)
    },
    async openMyProfile () {
      this.loading = true
      this.actResetUsuarioSelecionado()
      await this.actUsuarioSelecionado(this.id)
      this.loading = false
      this.dialog = true
    },
    fecharModal () {
      this.$refs.formPerfilUsuario.$destroy()
      this.dialog = false
    },
    callGravar () {
      this.$refs.formPerfilUsuario.gravar()
    }
  },
  computed:{
    ...mapState({
      email: state => state.login.user.ds_email,
      id: state => state.login.user.id,
      avatar: state => state.login.user.avatar,
    }),
    ...mapState('usuario', [
      'loadingStore'
    ]),
  }
}
</script>

<style>
  .v-toolbar {
    flex: none !important;
  }

  .v-toolbar__content {
    height: 48px !important;
  }
  

  #core-toolbar a {
    text-decoration: none;
  }

  #core-toolbar .v-toolbar__items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: auto;

  }

  #core-toolbar .v-btn .v-btn--fab .v-size--small {
    height: 30px !important;
    width: 30px !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/core/Toolbar.vue